import React, { useImperativeHandle, useState } from "react";
import { Popup, Position, ToolbarItem } from 'devextreme-react/popup';
import { LoadIndicator } from "devextreme-react";
import Button from 'devextreme-react/button';

type Props = {
}

export type ProductSheetPopupHandle = {
  show: (link: string) => void
  hide: () => void
}

type State = {
  link: string,
  visible: boolean,
  fullscreen: boolean,
  txthint: string,
  loading : boolean
}

const PopupProductSheet: React.ForwardRefRenderFunction<ProductSheetPopupHandle, Props> = (props, ref) => {
  const [state, setState] = useState<State>({ visible: false, link: "", fullscreen: false, txthint: "", loading: false });

  useImperativeHandle(ref, () => ({
    show(link) {
      setState({ visible: true, link: link, fullscreen: false, txthint: "Ingrandisci", loading: true });
    },
    hide() {
      setState({ visible: false, link: "", fullscreen: false, txthint: "", loading: false });
    },
  }));

  function hideLoadIndicator() {
    setState({ ... state, loading: false });
  }

  function setScreen() {
    setState({ ... state, fullscreen: !state.fullscreen, txthint: (state.txthint == 'Ingrandisci' ? 'Riduci' : 'Ingrandisci') });
  }

  return (
    <React.Fragment>
      <Popup
        visible={state.visible}
        dragEnabled={false}
        hideOnOutsideClick={true}
        showCloseButton={true}
        showTitle={true}
        onHidden={() => setState({ visible: false, link: "", fullscreen: false, txthint : "", loading: false })}
        title="Scheda prodotto"
        container=".dx-viewport"
        fullScreen={state.fullscreen}
        height={800}
        width={950}
      >
        <Position
          at="center"
          my="center"
          of=""
          collision="fit"
        />

        <ToolbarItem toolbar="top" location="after">
          <Button
            hint={state.txthint}
            icon='fullscreen'
            onClick={setScreen}
          />
        </ToolbarItem>        

        {state.loading &&
          <div style={{ position: "relative", bottom: 0, top: 0, left: 0, right: 0, height: 'auto', width: 'auto', verticalAlign: 'middle', textAlign: 'center' }}>
            <LoadIndicator id="medium-indicator" />
          </div>
        }

        {state.link !== "" &&
          <iframe name="myframe" src={state.link}
            onLoad={hideLoadIndicator}
            sandbox='allow-scripts ' /* blocca popup richiesta country e serve per sicurezza*/
            style={{
              display: "block",
              border: "none",
              height: "100%",
              width: "100%"
            }} allowFullScreen>
          </iframe>
        }

      </Popup>

    </React.Fragment>
  );
}

export default React.forwardRef(PopupProductSheet);

